import { CancelTokenSource } from 'axios';

import { makeRestApiRequest, RestApiRequestConfig } from '~src/httpClient/RestApiService';

// import { makeRestApiRequest, RestApiRequestConfig } from '../services/RestApiService';

export const UploadWorkbookRequestConfig: Omit<RestApiRequestConfig<WorkbookUploadRequestBody, WorkbookUploadQueryParams>, 'requestBody' | 'headers' | 'queryParams'> = {
  restApiVersion: '3.6',
  httpMethod: 'POST',
  endpoint: 'workbooks',
};

export enum UploadWorkbookErrorCodes {
  PUBLISHING_UNAUTHORIZED = 403007,
  PUBLISHING_OVERWRITE = 403130
}

export interface WorkbookUploadQueryParams {
  overwrite: boolean;
}

export type WorkbookUploadRequestBody = Blob;

export interface WorkbookUploadResponse {
  workbook: {
    id: string;
    contentUrl: string;
    defaultViewId: string;
    views: {
      view: WorkbookView[];
    };
    webpageUrl: string;
  };
}

export interface WorkbookView {
  id: string;
  viewUrlName: string;
}

export function callViaApiService(
  body: WorkbookUploadRequestBody,
  headers: {[index: string]: string},
  queryParams: WorkbookUploadQueryParams,
  progressDispatcher?: (progres: any) => void,
  cancelToken?: CancelTokenSource
) {
  const config: RestApiRequestConfig<WorkbookUploadRequestBody, WorkbookUploadQueryParams> = {
    ...UploadWorkbookRequestConfig,
    requestBody: body,
    headers,
    queryParams,
    onUploadProgress: progressDispatcher,
    cancelToken
  };
  return makeRestApiRequest<Blob, WorkbookUploadResponse>(config);
}

